import {
  FILTER_ENGAGEMENT_SCORES,
  GET_ENGAGEMENT_SCORE_FOR_ACCESSIBLE,
  RESET_ACCESSIBLE_ENGAGEMENT_DATA
} from './accessible-action-types'
import {SET_ENGAGEMENT_SCORE_FOR_ACCESSIBLE, SET_FILTERED_ENGAGEMENT_SCORE_BY_WEEK, RESET_ACCESSIBLE_ENGAGEMENT} from './accessible-mutation-types'
import server from '../../server'
import {getDateFromString} from '../../../utils/date'

const state = {
  engagementScore: [],
  engagementScoreFiltered: []
}

const mutations = {
  [SET_ENGAGEMENT_SCORE_FOR_ACCESSIBLE] (state, data) {
    data.forEach((dt) => {
      dt.engagementScoreDate = formatDate(dt.engagementScoreDate)
    })
    state.engagementScore = data
    state.engagementScoreFiltered = data
    state.engagementScoreFiltered = filterResourcesByWeeks(4)
  },
  [SET_FILTERED_ENGAGEMENT_SCORE_BY_WEEK] (state, filter) {
    if (filter === 'TEN_WEEKS') {
      state.engagementScoreFiltered = state.engagementScore
    } else if (filter === 'FOUR_WEEKS') {
      state.engagementScoreFiltered = filterResourcesByWeeks(4)
    } else if (filter === 'ONE_WEEK') {
      state.engagementScoreFiltered = filterResourcesByWeeks(1)
    }
  },
  [RESET_ACCESSIBLE_ENGAGEMENT] (state) {
    state.engagementScore = []
    state.engagementScoreFiltered = []
  }
}

const actions = {
  [GET_ENGAGEMENT_SCORE_FOR_ACCESSIBLE] ({rootState, commit}, payload) {
    const url = `/core/engagement/accessible/${payload.studentId}/${payload.cohortId}/${payload.fromDate}/${payload.toDate}`
    const actionData = { action: GET_ENGAGEMENT_SCORE_FOR_ACCESSIBLE, data: payload }
    server.getReplayable(url, actionData).then(response => {
      commit(SET_ENGAGEMENT_SCORE_FOR_ACCESSIBLE, response.data)
    })
  },
  [FILTER_ENGAGEMENT_SCORES] ({rootState, commit}, filter) {
    commit(SET_FILTERED_ENGAGEMENT_SCORE_BY_WEEK, filter)
  },
  [RESET_ACCESSIBLE_ENGAGEMENT_DATA] ({commit}) {
    commit(RESET_ACCESSIBLE_ENGAGEMENT)
  }
}

function filterResourcesByWeeks (filter) {
  const selectedDate = new Date().setDate(new Date().getDate() - (7 * filter))
  const filtered = state.engagementScore.filter((item) => {
    const date = getDateFromString(item.engagementScoreDate)
    return date >= selectedDate
  })
  return filtered
}

function formatDate (value) {
  const date = new Date(value)
  const year = date.getFullYear()
  let month = date.getMonth() + 1
  let dt = date.getDate()
  if (dt < 10) {
    dt = '0' + dt
  }
  if (month < 10) {
    month = '0' + month
  }
  return dt + '/' + month + '/' + year
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/accessibility/accessibleEngagement.js